import Fetch from 'utils/fetch';

export const AcceptCancel = (idPedido) => {
  return Fetch.post(`/orders/${idPedido}:accept`).then(({ data }) => data);
}

export const RefuseCancel = (idPedido) => {
  return Fetch.post(`/orders/${idPedido}:refuse`).then(({ data }) => data);
}

export const RefuseCheckCancel = (idPedido) => {
  return Fetch.put(`/pedido/ConfirmCancellationRefused/${idPedido}`).then(({ data }) => data);
}
